import React, { useEffect } from 'react';
import { GameInterface } from '../constants/GameInterface';
import { Dialogs } from '../constants/Dialogs';
import HeaderInGame from '../HeaderInGame';
import { PageView } from '../classes/PageView';
import { Pages } from '../constants/Pages';

function StartJoinGameDialog({dialog, setDialog, setIsHost}: GameInterface) {

    const handleStartGame = () => {
        setIsHost(true);
        setDialog(Dialogs.info);
    }

    const handleJoinGame = () => {
        setIsHost(false);
        setDialog(Dialogs.info);
    }

    useEffect(() => {
        PageView.addNewPageView(Pages.StartJoinGame);
    }, [])

    return (
        <div className="overallWrapper">
            <HeaderInGame/>
            <div className="startJoinGameWrapper">
                <button className="startJoinGameStartGame" onClick={handleStartGame}>START GAME</button>
                <button className="startJoinGameJoinGame" onClick={handleJoinGame}>JOIN GAME</button>
            </div>
        </div>
    );
};

export default StartJoinGameDialog;